import OperatingViewOperator from '@/module/monitoringCenter/page/operatingView_operator.vue'
import layout from '@/layout/index'
// 导出配置的路由器
export default [{
        path: '/monitoringCenter',
        component: layout,
        redirect: 'monitoringCenter/operatingView_operator',
        meta: { title: '监控中心', icon: 'icon-yunwei', perms: ['bee:monitor'] },
        children: [
            {
                path: 'operatingView_operator',
                component: OperatingViewOperator,
                meta: { title: '运营总览(运营商版)', icon: 'icon-yingxiao1', perms: ['bee:order:operatorScreen'] }
            }
        ]
    }
  ,
  {
    path: '/personalCenter',
    component: () =>
      import ('@/layout/index'),
    redirect: 'personalCenter/personalSettings',
    hidden: true, //隐藏
    meta: {
      title: '个人中心',
      icon: 'icon-geren'
    },
    children: [{
      path: 'personalSettings',
      name: 'personalSettings',
      component: () =>
        import ('@/module/systemManagement/page/personalSettings.vue'),
      meta: {
        title: '个人设置',
        icon: 'icon-caozuo'
      }
    }]
  }
]



// WEBPACK FOOTER //
// ./src/module/monitoringCenter/router/index.js